import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button } from '../../../../../components/common/buttons/Button';
import { SlideConfirmModal } from '../../../../../components/common/modal/slide/SlideConfirmModal';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/store/useStore';
import { FilterOptionValueType } from '../../../../../interfaces/Filter.interfaces';
import { filterSlice } from '../../../../../store/filterSlice';

interface DirectDealSortSlideModalProps {
  isShow: boolean;
  closeModal: () => void;
}

export const DirectDealSortSlideModal = ({ isShow, closeModal }: DirectDealSortSlideModalProps) => {
  const dispatch = useAppDispatch();
  const filterActions = filterSlice.actions;
  const sorterFilter = useAppSelector((state) =>
    state.filter.directDealFilter.globalFilters.find((filter) => filter.key === 'sorter'),
  );

  const appliedSortValue = sorterFilter?.options.find((option) => option.isSelected)?.value;
  const [selectedSortValue, setSelectedSortValue] = useState<FilterOptionValueType | undefined>(appliedSortValue);

  // 적용하지 않고 닫은 선택이 다음에 열 때 남아 있지 않도록, 열 때마다 적용된 정렬로 되돌린다.
  useEffect(() => {
    if (isShow) {
      setSelectedSortValue(appliedSortValue);
    }
  }, [isShow, appliedSortValue]);

  const handleApplyButtonClick = () => {
    const targetOption = sorterFilter?.options.find((option) => option.value === selectedSortValue);

    if (sorterFilter && targetOption) {
      dispatch(
        filterActions.changeFilterOptionIsSelected({
          filterType: 'directDealFilter',
          targetFilter: sorterFilter,
          targetOption,
        }),
      );
    }

    window.scrollTo(0, 0);
    closeModal();
  };

  return (
    // 상단 여백을 필터 바텀시트와 맞추려고 모달 기본 여백을 없애고, 적용 버튼까지 내용 안에서 배치한다.
    <SlideConfirmModal
      isShow={isShow}
      element={
        <Container>
          <SortOptionList>
            {sorterFilter?.options.map((option) => (
              <SortOption key={option.value} onClick={() => setSelectedSortValue(option.value)}>
                <SortOptionName>{option.optionName}</SortOptionName>
                <Radio>{option.value === selectedSortValue && <RadioChecked />}</Radio>
              </SortOption>
            ))}
          </SortOptionList>

          <Button
            size={'md'}
            borderType={'square'}
            color={'filledPrimaryStrong'}
            text={{ size: 'md', content: '적용하기' }}
            onClick={handleApplyButtonClick}
          />
        </Container>
      }
      closeButton={{ handleClick: closeModal }}
      isShowCloseButton
      gap={'0px'}
      padding={'0px'}
    />
  );
};

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 16px 24px 32px 24px;
  gap: 24px;
`;

const SortOptionList = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SortOption = styled.button`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 16px 0px 16px 16px;
`;

const SortOptionName = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 13.6px */
`;

const Radio = styled.div`
  width: 16px;
  height: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50px;
  border: 1px solid var(--Light-Scheme-Monochrome-grey30, #e0e0eb);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const RadioChecked = styled.div`
  width: 10px;
  height: 10px;

  border-radius: 50px;
  background: var(--Light-Scheme-Color-primary-blue, #196eff);
`;
